/**
 * Sentry init for the admin SPA — Wave 2.33 BE-2 (TASK-013a).
 *
 * `VITE_*` env vars are injected at build time by Vite. When
 * `VITE_SENTRY_DSN` is empty (local dev, preview builds without the
 * secret), the SDK is initialised with `enabled: false` so no events
 * leave the browser and no transport is bound — same no-op contract as
 * the API/worker copies.
 *
 * Called from `main.tsx` BEFORE `createRoot(...)` so even the very first
 * render-phase exception is captured.
 */

import * as Sentry from '@sentry/react';
import { redactPii } from './sentry-pii-redact';

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: parseFloat(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.1',
    ),
    enabled: Boolean(dsn),
    beforeSend: redactPii,
  });
}

export { Sentry };
